import { ErrorContent } from "./ErrorContent";

export const UnexpectedErrorView = ({ err }: { err: Error | null }) => (
  <ErrorContent
    title="エラーが発生しています。"
    description="しばらく時間をおいてから再度お試しください。"
  />
);
